import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  gap: 40px;
  width: 100%;
  font-family: ${({ theme }) => theme.font.fontFamily};

  color: ${({ theme }) => theme.colors.neutral.white};

  button {
    width: 30%;
  }

  ${({ isDownload, theme }) =>
    isDownload &&
    `
    background-color: ${theme.colors.neutral.cinza950};
    padding: 20px;
    width: 870px;
  `}
`;

export const ProjectHeader = styled.div`
  display: flex;

  width: 100%;
  gap: 10px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    max-height: 100px;
    max-width: 230px;
  }
`;

export const Infos = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  padding: 15px;

  h1 {
    font-size: 18px;
    color: ${({ theme }) => theme.colors.neutral.white};
  }

  span {
    font-size: 14px;
    color: ${({ theme }) => theme.colors.neutral.cinza200};
  }
`;
